export default __webpack_public_path__ + "static/media/FlipCard.2ed3da92.wav";